import script from "./AnnotationToolAGTGRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationToolAGTGRibbon.vue?vue&type=script&setup=true&lang=js"

import "./AnnotationToolAGTGRibbon.vue?vue&type=style&index=0&id=67b5c331&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b5c331"]])

export default __exports__